import { Routes } from '@angular/router';
import { PageTitleEnum } from '@shared/enums';
import { userGuard } from '@core/guards';

export const strainDetailsRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./_strain-details-layout/strain-details-layout.component').then(
                mod => mod.StrainDetailsLayoutComponent
            ),
        children: [
            {
                path: '',
                redirectTo: 'overview',
                pathMatch: 'full',
            },
            {
                path: 'overview',
                loadComponent: () =>
                    import('./strain-details-overview/strain-details-overview.component').then(
                        mod => mod.StrainDetailsOverviewComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.STRAIN_OVERVIEW,
                data: { preload: true },
            },
            {
                path: 'translate-results',
                loadComponent: () =>
                    import('./strain-translate-results/strain-translate-results.component').then(
                        mod => mod.StrainTranslateResultsComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.STRAIN_TRANSLATIONS,
            },
            {
                path: 'share',
                loadComponent: () =>
                    import('./strain-sharing/strain-sharing.component').then(mod => mod.StrainSharingComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.STRAIN_SHARE,
            },
            {
                path: 'strain-information-form',
                loadComponent: () =>
                    import('./strain-information-form/strain-information-form.component').then(
                        mod => mod.StrainInformationFormComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.STRAIN_INFORMATION_FORM_DETAILS,
            },
            {
                path: 'approve-results',
                loadComponent: () =>
                    import('./strain-approve-results/strain-approve-results.component').then(
                        mod => mod.StrainApproveResultsComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.STRAIN_APPROVE_RESULTS,
            },
            {
                path: 'messages',
                loadComponent: () =>
                    import('./strain-messages/strain-messages.component').then(mod => mod.StrainMessagesComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.STRAIN_MESSAGES,
            },
        ],
    },
];
